module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "ch06"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    staticClass: "nounderb",
    attrs: {
      "href": "#/xhtml/content"
    }
  }, [_c('span', {
    staticClass: "txbdco"
  }, [_vm._v("Date: August 16")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbdco"
  }, [_vm._v("Time: 1:00 p.m")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbdco"
  }, [_vm._v("Place: Green Room, the practice")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbdco"
  }, [_vm._v("Patient: Charlotte Mimer")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("“Charlotte, I think we should start by looking at how things have been going for you over the summer. It’s been a long summer break.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think the summer was just fine. I’ll be happy to show you my entries.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlotte Mimer bends over her briefcase and pulls out a folder where the pages of her food diary are in perfect order. I note that as usual she has made all her entries with the same pen and in her signature tidy handwriting. Charlotte hands over the folder to me as she pushes her well-coiffed brown hair behind one ear. I see that she is expectant and proud, and I feel happy for her sake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s start by looking at the entries from June.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This summer I had asked Charlotte to take notes about every meal: where she was, what she ate, and how much. And at the end of each meal she would assess her uneasiness and distress. For an individual with a serious eating disorder, ordinary mealtimes often give rise to strong anxiety; food is associated with fat. To avoid this feeling, certain destructive behaviors develop and may last for years: starvation, vomiting, and excessive exercise. The patient may not even be aware that all this leads to renewed bingeing, and yet the anxiety is so strong and painful that for the moment it doesn’t matter. It’s a vicious cycle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pick up Charlotte’s meticulous food diary and look through the entries for June. Regular mealtimes, no high-anxiety estimates after finished meals, no overeating, no vomiting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you tell me about it?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“I don’t know… it just went fine. Suddenly it was… easy.”")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlotte is about forty years old and successful in business. She works as a marketing manager at a large international company. She has struggled with eating disorders in silence for almost twenty-five years. It was only when her dentist confronted her about the corrosion damage to her teeth that she sought help. She has been in treatment since the end of April and is something of a model patient. Just as she is a perfect marketing manager, she is also the perfect psychotherapy patient. Her major problems seem to stem from the incredibly high demands she places on herself. Charlotte is scared to death of failing. So far we have touched on this only peripherally, working on reducing her bingeing and vomiting. In contrast to Sara Matteus, Charlotte seems to spread energy around her. Her fear of being incompetent or inadequate makes me feel accomplished and capable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We continue to study Charlotte’s notes. July, August: low anxiety, no vomiting. We find ourselves laughing together, and Charlotte finally gets the praise she so desires, and that she also deserves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There was something else, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlotte looks hesitant. She squirms in the 1950s-style Lamino chair and, as always when she is worried, she starts wiggling one foot, today clad in a Tod’s loafer. I suspect this is a type of shoe I could never afford.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlotte suddenly looks as if she is keeping a secret. A secret that she will soon tell me. You see, that’s the way it works: They tell me all their secrets in the little green room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know if it has to do with therapy exactly. I’ve been thinking, you know, about life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlotte stops herself and a blush creeps up her neck. I realize that it takes a lot of courage for her to bring up what she now wants to say.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“I’ve spent… how many years is it really—good Lord, twenty-five, maybe?—devoting all my time to thinking about food. And about my body. And about my stomach. And about my thighs. And about going to the gym. When I wasn’t doing that, I was working. Work. Body. Food. ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I’m the youngest, most successful marketing manager at the whole company, but I have no life. No "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("real")]), _vm._v(" life. No friends. No "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("close")]), _vm._v(" friends, anyway. No husband. No children. I’ve been so preoccupied with making myself perfect that I’ve forgotten why I wanted to be perfect. I wanted… to be… loved. I want to be loved. And now it’s too late.”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The tears have burst forth and are running down Charlotte’s blushing cheeks like little streams. She sniffs and takes several tissues from the box. Blows her nose, dries her tears, and cries some more. I push the box across the table toward her and place my hand lightly on her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Charlotte.” I catch her gaze. “It’s not unusual to feel this way when you’re going through what you are right now… You’ve been handicapped, held back by a severe illness, and now you’re starting to get healthy. Of course there will be insight into the years you’ve missed. It’s not strange. It’s good. What I want to know is why you say it’s too late now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sits silently while inspecting the wall above my head before answering in a cracked voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Old, I’m getting old. And it’s as if I can’t understand it, can’t take it in. It’s like I’m just waiting to… that I’ll be young again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Young again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, by spring maybe?” she says and smiles—a crooked, melancholy smile, filled with pain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smile back. The thought sounds familiar somehow, as if time were a channel, where it was possible to travel in both directions under controlled circumstances, instead of a waterfall. She shrugs slowly and fixes me with a dejected look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who will want me now… I am… maybe I can’t even have children now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlotte’s sorrow. Charlotte’s fear. So close to my own. No children. Too late. No husband. No idea. Never again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I try to collect Charlotte’s thoughts and do something with them. Get her to look at them from outside. Objectively. Assess the level of truth in these assertions. We agree on an assignment for Charlotte to work on, and then her forty-five minutes are over and she takes out a brush, ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("pulls it through her hair, and somehow manages to collect herself. When she shakes my hand and says good-bye, the sobbing little girl Charlotte Mimer is no longer there. Out of the room walks marketing manager Charlotte Mimer and I, psychotherapist Siri Bergman, stay behind.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I go to the window and look down at the street. Far below me, on the stone pavement of Medborgarplatsen, a group of preschool children walks by. The August sun is shining like it doesn’t have the sense not to. No noise penetrates my office, but when I close my eyes I can imagine how the children’s voices sound down there. A quiet feeling that I cannot identify fills my chest. Maybe it’s sorrow, maybe it’s only calm and emptiness.")]), _vm._v(" "), _c('p', {
    staticClass: "imagecm1"
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "height": "45",
      "src": "images/common.jpg",
      "width": "60"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1369aee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch06.vue
// module id = 96
// module chunks = 0